import { GET_UI_CONFIGURATION } from "./ActionTypes";

export class UIConfigurationActions {
    static setUIconfiguration = (data: any) => {
        return {type: GET_UI_CONFIGURATION, payload: data ? data : []}
    }
}